// this function return staff inofrmation of  branch whose bId is passed.
export function getStaffInfoById(bId) {
  let data = JSON.parse(localStorage.getItem("staffRegister"));
  console.log("data", data);
  console.log("bId", bId);
  const output = data.find((d) => {
    if (d.branchId == bId) return true;
  });
  console.log(output);
  return output?.staffRoll || [];
}

// this function replaces updated data of staff for particular bId
export function setStaffData(bId, data) {
  console.log("data", data);
  // getting whole staffRegister object .
  let d1 = JSON.parse(localStorage.getItem("staffRegister"));
  console.log(d1);

  const output = d1.map((item) => {
    if (item.branchId == bId) {
      let obj = {
        branchId: bId,
        staffRoll: data,
      };
      return obj;
    } else return item;
  });

  // setting updated data to local Storage
  console.log(output);
  localStorage.setItem("staffRegister", JSON.stringify(output));
}

export function deleteStaffEntry(bId, id) {
  // getting whole staff Register
  let staffReg = JSON.parse(localStorage.getItem("staffRegister"));

  // getting branch specific staff info
  let branchData = getStaffInfoById(bId);

  // deleting begins (filteration);
  const output = branchData.filter((item) => {
    if (item.id == id) return false;
    else return true;
  });

  // looping through whole staff Register to attach updated data after deletion

  const result = staffReg.map((item) => {
    if (item.branchId == bId) {
      let obj = {
        branchId: bId,
        staffRoll: output,
      };
      return obj;
    } else return item;
  });

  // now place result in local storage since this is updated object of staff register

  localStorage.setItem("staffRegister", JSON.stringify(result));
}
